import { render, staticRenderFns } from "./CommonCollapse2.vue?vue&type=template&id=29a6dac5&scoped=true&"
import script from "./CommonCollapse2.vue?vue&type=script&lang=js&"
export * from "./CommonCollapse2.vue?vue&type=script&lang=js&"
import style0 from "./CommonCollapse2.vue?vue&type=style&index=0&id=29a6dac5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a6dac5",
  null
  
)

export default component.exports